var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitalAzul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_558247",
    "data-name": 558247,
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.48,
    height: 45.606,
    viewBox: "0 0 45.48 45.606",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_383",
    "data-name": "Grupo 383",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_382",
    "data-name": "Grupo 382",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_231",
    "data-name": "Trazado 231",
    d: "M41.045,44.142V17.775L42.921,18.9l2.837-5.081L23.44,0,1.122,13.807,3.959,18.9l1.876-1.122V44.142H.7v1.463H46.18V44.142ZM4.506,16.86,3.088,14.319,23.44,1.724l20.352,12.6L42.374,16.86,23.44,5.548ZM39.573,44.142H7.307V16.9L23.44,7.263,39.573,16.9Z",
    transform: "translate(-0.7)",
    fill: "#409cce"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_385",
    "data-name": "Grupo 385",
    transform: "translate(12.47 19.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_384",
    "data-name": "Grupo 384"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_232",
    "data-name": "Trazado 232",
    d: "M139.6,222v20.541h20.541V222Zm19.068,19.077h-17.6v-17.6h17.6Z",
    transform: "translate(-139.6 -222)",
    fill: "#409cce"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_387",
    "data-name": "Grupo 387",
    transform: "translate(16.133 23.602)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_386",
    "data-name": "Grupo 386"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_233",
    "data-name": "Trazado 233",
    d: "M189.943,266.563V262.9h-5.871v3.672H180.4v5.871h3.672v3.663h5.871v-3.672h3.672v-5.871Zm2.2,4.408h-3.672v3.672h-2.936v-3.672h-3.672v-2.936h3.672v-3.672h2.936v3.672h3.672Z",
    transform: "translate(-180.4 -262.9)",
    fill: "#409cce"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalAzul);
export default __webpack_public_path__ + "static/media/hospital-azul.1bed43196ca28858354a864aa1f4f447.svg";
export { ForwardRef as ReactComponent };